import React from "react";

const AuditDots = () => {
  const keyframes = `
    @keyframes dotPulse {
      0%, 80%, 100% { transform: scale(0); opacity: 0.3; }
      40% { transform: scale(1); opacity: 1; }
    }
  `;

  const containerStyle: React.CSSProperties = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    marginTop: "10px",
    height: "24px",
  };

  const dotStyle = (delay: string): React.CSSProperties => ({
    width: "10px",
    height: "10px",
    backgroundColor: "#818cf8", // matches CaseKaizen purple
    borderRadius: "50%",
    animation: `dotPulse 1.2s infinite ${delay}`,
  });

  return (
    <>
      <style>{keyframes}</style>
      <div style={containerStyle}>
        <div style={dotStyle("0s")}></div>
        <div style={dotStyle("0.2s")}></div>
        <div style={dotStyle("0.4s")}></div>
      </div>
    </>
  );
};

export default AuditDots;
